import React, { useEffect, useState } from "react";
import { apiAdminContacts, apiAdminMarkContactHandled } from "../lib/api";
import { Mail, Check, Inbox } from "lucide-react";
import { toast } from "sonner";

const AdminContacts = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("all");

  const load = async () => {
    setLoading(true);
    setItems(await apiAdminContacts());
    setLoading(false);
  };
  useEffect(() => { load(); }, []);

  const toggle = async (id, current) => {
    await apiAdminMarkContactHandled(id, !current);
    toast.success(current ? "Marked unhandled" : "Marked handled");
    load();
  };

  const filtered = items.filter((c) => {
    if (filter === "open") return !c.handled;
    if (filter === "handled") return c.handled;
    return true;
  });

  return (
    <div className="p-10" data-testid="admin-contacts-page">
      <div className="flex items-center gap-3 mb-2">
        <div className="h-px w-8 bg-[#b91c1c]" />
        <span className="text-[10px] font-semibold tracking-[0.32em] uppercase text-[#b91c1c]">Inbox</span>
      </div>
      <h1 className="font-display text-4xl font-semibold text-[#0a0a0a] tracking-tight mb-8">Contact Messages</h1>

      <div className="flex gap-2 mb-5">
        {["all", "open", "handled"].map((f) => (
          <button
            key={f}
            onClick={() => setFilter(f)}
            className={`px-4 h-9 text-[11px] font-semibold uppercase tracking-[0.18em] border ${
              filter === f ? "bg-[#0a0a0a] text-white border-[#0a0a0a]" : "bg-white text-gray-600 border-gray-300 hover:border-[#0a0a0a]"
            }`}
          >
            {f}
          </button>
        ))}
      </div>

      {loading ? (
        <div className="text-sm text-gray-500">Loading…</div>
      ) : filtered.length === 0 ? (
        <div className="bg-white border border-gray-200 p-12 text-center text-gray-500">
          <Inbox className="h-8 w-8 mx-auto mb-3 text-gray-300" />
          <p>No messages.</p>
        </div>
      ) : (
        <div className="bg-white border border-gray-200 divide-y divide-gray-100">
          {filtered.map((c) => (
            <div key={c.id} className="p-5 hover:bg-[#fafbfc]" data-testid={`contact-row-${c.id}`}>
              <div className="flex items-start justify-between gap-4">
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-3 mb-1 flex-wrap">
                    <strong className="text-[#0a0a0a]">{c.name}</strong>
                    <a href={`mailto:${c.email}`} className="text-[12px] text-gray-500 hover:text-[#b91c1c] flex items-center gap-1">
                      <Mail className="h-3.5 w-3.5" /> {c.email}
                    </a>
                    {c.handled && (
                      <span className="text-[10px] font-semibold uppercase tracking-[0.18em] px-2 py-0.5 bg-green-100 text-green-700">Handled</span>
                    )}
                  </div>
                  {c.subject && <div className="text-[13px] font-medium text-[#0a0a0a] mt-1">{c.subject}</div>}
                  <p className="text-sm text-gray-600 mt-2 leading-relaxed whitespace-pre-line">{c.message}</p>
                  <div className="text-[11px] text-gray-400 mt-3 uppercase tracking-[0.18em]">
                    {new Date(c.createdAt).toLocaleString()}
                  </div>
                </div>
                <button
                  onClick={() => toggle(c.id, c.handled)}
                  className={`shrink-0 inline-flex items-center gap-1 h-8 px-3 text-[11px] font-semibold uppercase tracking-[0.18em] border ${
                    c.handled ? "border-gray-300 text-gray-500" : "border-[#0a0a0a] text-[#0a0a0a] hover:bg-[#0a0a0a] hover:text-white"
                  }`}
                  data-testid={`mark-handled-${c.id}`}
                >
                  <Check className="h-3.5 w-3.5" /> {c.handled ? "Unhandled" : "Mark handled"}
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AdminContacts;
